import React, { useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Logo from '../../app/common/Logo';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getApiKey, getUrl } from '../../app/api/agent';
import { Alert } from '@mui/material';
import {
  setUserData,
  setUserSessionEmail,
} from '../../app/services/AuthService';
import emailValidator from 'email-validator';
import DarkLogo from '../../app/common/DarkLogo';
import { useLocation } from 'react-router-dom';

const RegisterSecondary = () => {
  const location = useLocation();
  const pathName = location.pathname;
  const [searchParams] = useSearchParams();
  const paramEmail = decodeURIComponent(
    searchParams.get('Email') || searchParams.get('email') || ''
  );
  const paramProductId = decodeURIComponent(
    searchParams.get('productId') || searchParams.get('product_id') || ''
  );
  const paramFName = decodeURIComponent(
    searchParams.get('Name') ||
      searchParams.get('fname') ||
      searchParams.get('firstname') ||
      searchParams.get('first_name') ||
      searchParams.get('firstName') ||
      ''
  );
  const paramLName = decodeURIComponent(
    searchParams.get('lname') ||
      searchParams.get('lastname') ||
      searchParams.get('last_name') ||
      searchParams.get('lastName') ||
      ''
  );

  const [email, setEmail] = useState(paramEmail);
  const [authenticating, setAuthenticating] = useState(false);
  const [verifyPassword, setVerifyPassword] = useState('');
  const [passwordError, setPasswordError] = useState(null);
  const [verifyPasswordError, setVerifyPasswordError] = useState(null);
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState('success');
  const navigate = useNavigate();
  const setEmailForm = (value) => {
    setEmail(value.toLowerCase());
  };

  const submitHandler = (event) => {
    event.preventDefault();

    if (!emailValidator.validate(email)) {
      setTimeout(() => {
        setMessage(null);
      }, 3000);
      setMessage('Invalid email address');
      setMessageType('error');
      return;
    }
    if (
      !password.match(
        /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/
      )
    ) {
      setPasswordError(
        'Password must contain one digit from 1 to 9, one lowercase letter, one uppercase letter, one special character, no space, and it must be 8-16 characters long.'
      );
      return;
    } else {
      setPasswordError(null);
    }
    if (password !== verifyPassword) {
      setVerifyPasswordError('passwords do not match');
      return;
    } else {
      setVerifyPasswordError(null);
    }

    setMessage(null);
    setAuthenticating(true);
    const config = {
      url: getUrl() + '/register-child',
      method: 'post',
      data: {
        email: email,
        password: password,
        productId: paramProductId,
        fname: paramFName,
        lname: paramLName,
      },
      headers: {
        'x-api-key': getApiKey(),
        'Content-Type': 'application/json',
      },
    };
    axios(config)
      .then(() => {
        setMessage(
          'Registration Successful you will be automatically logged in.'
        );
        setEmail('');
        setPassword('');
        setAuthenticating(false);
        setMessageType('success');
        setTimeout(() => {
          login();
        }, 3000);
      })
      .catch((error) => {
        setMessageType('error');
        setAuthenticating(false);
        console.error('Error setting stage:', error);
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403)
        ) {
          setMessage(error.response.data.message);
        } else if (error.message) {
          setMessage(error.message);
        } else {
          setMessage('An unexpected error occurred, please try again later');
        }
      });
  };

  function login() {
    const loginconfig = {
      url: getUrl() + '/login',
      method: 'post',
      data: {
        email: email,
        password: password,
      },
      headers: {
        'x-api-key': getApiKey(),
        'Content-Type': 'application/json',
      },
    };
    axios(loginconfig)
      .then((response) => {
        setUserSessionEmail(response.data.user.email, response.data.token);
        setUserData(response.data.user);
        navigate('/');
      })
      .catch((error) => {
        setAuthenticating(false);
        console.error('Error setting stage:', error);
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403)
        ) {
          setMessage(error.response.data.message);
        } else if (error.message) {
          setMessage(error.message);
        } else {
          setMessage('An unexpected error occurred, please try again later');
        }
      });
  }

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        backgroundColor: 'background.paper',
        padding: 5,
        marginTop: 5,
      }}
    >
      {pathName.includes('register-ntai') && (
        <>
          <Typography component="h1" variant="h5">
            Thank You for Purchasing the NTAI
          </Typography>
          <Typography component="h4" variant="h5">
            Please register in Pompa Program's assessment application and
            complete the short 15 minute assessment to receive your analysis.
          </Typography>
        </>
      )}
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <DarkLogo />
        <Typography component="h1" variant="h5">
          Register
        </Typography>
        <Box
          component="form"
          onSubmit={submitHandler}
          noValidate
          sx={{ mt: 1 }}
        >
          <TextField
            margin="normal"
            required
            value={email}
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            onChange={(event) => setEmailForm(event.target.value)}
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          {passwordError && <Alert severity={'error'}>{passwordError}</Alert>}
          <TextField
            margin="normal"
            required
            fullWidth
            value={verifyPassword}
            onChange={(event) => setVerifyPassword(event.target.value)}
            name="password"
            label="Verify Password"
            type="password"
            id="verify-password"
            autoComplete="verify-password"
          />
          {verifyPasswordError && (
            <Alert severity={'error'}>{verifyPasswordError}</Alert>
          )}
          <Button
            disabled={authenticating}
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Register
          </Button>
          <Grid container>
            <Grid item>
              <Link href="/login" variant="body2">
                {'Already have account? Sign In'}
              </Link>
            </Grid>
          </Grid>
          <div style={{ marginTop: '10px' }}>
            {message && <Alert severity={messageType}>{message}</Alert>}
          </div>
        </Box>
      </Box>
    </Container>
  );
};

export default RegisterSecondary;
